import authService from "../../services/orderService";
import {
  ORDERS_FETCH_FAILURE,
  ORDERS_FETCH_REQUEST,
  ORDERS_FETCH_SUCCESS,
} from "./actionTypes";

export const fetchOrders = (authUserId, page, pageSize,dateFilter,model) => {
  return async (dispatch) => {
    dispatch({ type: ORDERS_FETCH_REQUEST });
    try {
      const response = await authService.fetchOrders(authUserId, page, pageSize,dateFilter,model);
      const { data } = response;
      dispatch({
        type: ORDERS_FETCH_SUCCESS,
        payload: {
          orders: data.data,
          totalOrders: data.recordsTotal,
        },
      });
      return data;
    } catch (error) {
      dispatch({ type: ORDERS_FETCH_FAILURE, error: error.message });
      return Promise.reject(error);
    }
  };
};